"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationType = void 0;
var NotificationType;
(function (NotificationType) {
    NotificationType["endorsement"] = "endorsement";
    NotificationType["dimensionCompletion"] = "dimensionCompletion";
    NotificationType["highlight"] = "highlight";
    NotificationType["traitPermissionRequest"] = "traitPermissionRequest";
    NotificationType["nudge"] = "nudgeType";
    NotificationType["friendRequest"] = "friendRequest";
    NotificationType["quickAdd"] = "quickAdd";
    NotificationType["insightType"] = "insightType";
    NotificationType["friendArchetypeDiscovery"] = "friendArchetypeDiscovery";
    NotificationType["chatMessage"] = "chatMessage";
    NotificationType["updatedStory"] = "updatedStory";
    NotificationType["automatedDimensionCompletionReminder"] = "automatedDimensionCompletionReminder";
    NotificationType["dailyPrompt"] = "dailyPrompt";
    NotificationType["peerAssessmentActionable"] = "peerAssessmentActionable";
    NotificationType["peerAssessmentUnactionable"] = "peerAssessmentUnactionable";
    NotificationType["peerAssessmentRequest"] = "peerAssessmentRequest";
    NotificationType["updatedTraitEndorsements"] = "updatedTraitEndorsements";
    NotificationType["viewTraitRatingsModal"] = "viewTraitRatingsModal";
    NotificationType["viewCommentThread"] = "viewCommentThread";
    NotificationType["commentLiked"] = "commentLiked";
    NotificationType["commentReplied"] = "commentReplied";
    NotificationType["firstComment"] = "firstComment";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
